module.exports = __webpack_public_path__ + "static/media/quote1.b286e71f.png";